import React from 'react';
import ContentLoader from 'react-content-loader';

import Theme from 'styles/theme';

const WIDTH = 150;
const HEIGHT = 12;

const Rectangle = () => <rect width={WIDTH} height={HEIGHT} />;

const OverviewPlaceholder = props => (
  <div className="OverviewPlaceholder">
    <ContentLoader
      height={HEIGHT}
      width={WIDTH}
      speed={1}
      primaryColor={Theme.get('colors-black-20')}
      secondaryColor={Theme.get('colors-black-20')}
      animate={false}
      style={{ maxWidth: `${WIDTH}px` }}
      {...props}
    >
      <Rectangle />
    </ContentLoader>
    <style jsx>
      {`
        .OverviewPlaceholder {
          display: auto;
          margin-bottom: ${Theme.get('spacing-px')};
        }
      `}
    </style>
  </div>
);

export default OverviewPlaceholder;
